import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

// Get all events
const getEvents = async () => {
  const response = await axios.get(`${base_url}event`);
  if (response.data) {
    return response.data;
  }
};

// Get a single event by ID
const getEvent = async (id) => {
  const response = await axios.get(`${base_url}event/${id}`);
  if (response.data) {
    return response.data;
  }
};

export const eventService = {
  getEvents,
  getEvent,
};
